var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scrolling-touch -horizontal-offset no-scrollbar flex overflow-x-auto"},[_c('div',{staticClass:"w-4 flex-shrink-0 lg:hidden"}),_vm._v(" "),_c('div',{staticClass:"grid flex-grow grid-flow-col justify-start",class:{
      'gap-x-15px lg:gap-x-8': _vm.wideSpace,
      'gap-x-2.5 lg:gap-x-5': !_vm.wideSpace,
      'lg:grid-cols-2': _vm.cols === 2,
      'lg:grid-cols-3': _vm.cols === 3,
      'lg:grid-cols-4': _vm.cols === 4,
      'lg:grid-cols-5': _vm.cols === 5,
      'lg:grid-cols-6': _vm.cols === 6,
    }},[_vm._l((_vm.items),function(item){return [_vm._t("item",null,{"item":item})]})],2),_vm._v(" "),_c('div',{staticClass:"w-4 flex-shrink-0 lg:hidden"})])}
var staticRenderFns = []

export { render, staticRenderFns }